import { Link } from 'react-router-dom';
import './index.sass';

function NotFoundPage() {
	return (
		<main className='notFoundPage'>
			<h1 className='title'>404 - Not Found</h1>
			<Link to={'/'}>Home</Link>
		</main>
	);
}

export default NotFoundPage;
